import { render, staticRenderFns } from "./ModelTeamIncomeUserRecord.vue?vue&type=template&id=7ff50e15&scoped=true&"
import script from "./ModelTeamIncomeUserRecord.vue?vue&type=script&lang=js&"
export * from "./ModelTeamIncomeUserRecord.vue?vue&type=script&lang=js&"
import style0 from "./ModelTeamIncomeUserRecord.vue?vue&type=style&index=0&id=7ff50e15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff50e15",
  null
  
)

export default component.exports